module.exports = __webpack_public_path__ + "static/media/logoHSMobile.0f6b80d0.png";